export { default as RedTimerIcon } from './ic_timer.svg';
export { default as Metapo24X24Icon } from './metapo_24x24.svg';
export { default as Metapo48X48Icon } from './metapo_48x48.svg';
export { default as Metapo88X88Icon } from './metapo_88x88.svg';
